import React, { useState } from 'react';
import classnames from 'classnames';
import './index.scss';
import Exit from '../Exit';

const cars = [{
  uid: '2abb7d771c73d98333489ddd0c7f5063183673ac',
  name: '奥迪-A8',
  thumb: '36569e0c28df6d844450d25e40a29929.png',
}, {
  uid: '2abb7d771c73d98333489ddd0c7f506318361234',
  name: '奥迪-A4',
  thumb: '36569e0c28df6d844450d25e40a29929.png',
}];

export default function Differ({ onChange, onExit }) {
  const [ currentUid, setCurrentUid ] = useState(cars[0].uid);
  const [ open, setOpen ] = useState(false);
  return (
    <div className="differ-wrapper" >
      <div className="differ-header-wrapper">
        <Exit text="退出对比" onClick={onExit} className="differ-exit" />
        <button className="car-list-btn" onClick={() => setOpen(true)}>
          <span className="shadow-box"></span>
          <span className="inner">
            更换车型
          </span>
        </button>
      </div>
      {open &&
      <div className="car-wrapper">
        <Exit text="返回" onClick={() => setOpen(false)}/>
        <p className="text">选择对比车型</p>
        <ul className="car-list">
          {cars.map(v =>
            <li 
              role="button"
              className={classnames({ active: currentUid === v.uid})}
              onClick={() => {
                setCurrentUid(v.uid);
                onChange(v.uid)
              }}
              key={v.uid}
            >
              <img src={require(`../../images/${v.thumb}`)} alt="" />
              <p>{v.name}</p>
            </li>
          )}
        </ul>
      </div>}
    </div>
  )
}